import React, { useState } from "react";

export default function PreviewLoginInput({
  label = "Preview Login as:",
  placeholder = "",
  defaultValue = "",
  buttonText = "Apply",
  onApply,
  onReset,
  style = {},
  inputType = "text",
}) {
  const [value, setValue] = useState(defaultValue);

  // Reset input value to defaultValue
  const handleReset = () => {
    if (onReset) onReset(value);
  };
  const handleApply = () => {
    if (onApply) onApply(value);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        background: "#eee",
        padding: "4px 8px",
        borderRadius: "0px",
        width: "auto",
        ...style,
      }}
    >
      <span
        style={{
          fontWeight: 500,
          fontSize: "14px",
          minWidth: "70px",
          marginRight: "4px",
          color: "#222",
        }}
      >
        {label}
      </span>
      <input
        type={inputType}
        value={value}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        style={{
          border: "1px solid #d4dbe5",
          borderRadius: "6px",
          padding: "3px 8px",
          fontSize: "14px",
          background: "#fff",
          width: "270px",
          height: "35px",
          boxSizing: "border-box",
          marginTop: "8px",
        }}
      />
      <button
        type="button"
        onClick={handleApply}
        style={{
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "16px",
          padding: "4px 16px",
          fontWeight: "600",
          fontSize: "13px",
          cursor: "pointer",
          height: "28px",
        }}
      >
        {buttonText}
      </button>
      <button
        type="button"
        onClick={handleReset}
        style={{
          background: "#fff",
          color: "#2563eb",
          border: "1px solid #2563eb",
          borderRadius: "16px",
          padding: "4px 12px",
          fontWeight: "500",
          fontSize: "13px",
          cursor: "pointer",
          height: "28px",
          marginLeft: "4px",
        }}
        title="Reset"
      >
        Reset
      </button>
    </div>
  );
}
